// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	1008: 0,
	5736: 0,
	920: 0,
	7284: 0,
	2128: 0,
	5496: 0,
	5224: 0,
	4865: 0,
	4324: 0,
	4296: 0,
	8724: 0,
	6848: 0,
	6240: 0,
	9744: 0,
	4960: 0,
	7246: 0,
	8364: 0,
	6396: 0,
	7916: 0,
	0: 0,
	8368: 0,
	3640: 0,
	6768: 0,
	8960: 0,
	9396: 0,
	8712: 0,
	5388: 0,
	2212: 0,
	704: 0,
	8328: 0,
	7404: 0,
	2124: 0,
	8716: 0,
	7672: 0,
	4140: 0,
	72: 0,
	8796: 0,
	2653: 0,
	3512: 0,
	984: 0,
	1000: 0,
	4116: 0,
	3356: 0,
	3980: 0,
	1849: 0,
	2676: 0,
	2464: 0,
	7308: 0,
	876: 0,
	1536: 0,
	5068: 0,
	8232: 0,
	2860: 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunknyg_starter"] = self["webpackChunknyg_starter"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));